import { Component, input } from '@angular/core';
import { OnyxAvatarComponent } from '@onyx/angular';
import type { SimplifiedContractor } from '../../../../contractors/common/interfaces/contractor';

@Component({
  selector: 'app-points-of-interest-contractor-cell',
  imports: [OnyxAvatarComponent],
  templateUrl: './points-of-interest-contractor-cell.component.html',
  styleUrl: './points-of-interest-contractor-cell.component.scss',
})
export class PointsOfInterestContractorCellComponent {
  public readonly contractor = input.required<SimplifiedContractor | null>();
}
